import { isCloud } from '@blk/aw-env-detection';
import { conditionalParam as baseConditionalParam, ParamExclusionRule } from '../../utils/ApiUtils';
import { apbSettings } from './Base';

export const isAGraphEnabled = () => {
  // Temporarily only using AGraph APIs externally until the legacy internal ones are fixed by AGraph team
  if (isCloud()) {
    return apbSettings.getAGraphConfig?.()?.aladdinportfoliobuilder ?? false;
  }
  return false;
};

/**
 * Default exclusion rules for AladdinPortfolioBuilderServer AGraph/Cloud APIs that reject unknown query params
 */
const APB_SERVER_PARAM_EXCLUSION_RULES: ParamExclusionRule[] = [
  {
    urlPrefix: ['api/v4/fx'],
    excludedParams: ['pkg', 'configurationDirectory'],
  },
  {
    urlPrefix: ['api/v7/proposal/analysis'],
    excludedParams: ['configurationDirectory'],
  },
  {
    urlPrefix: ['/api/v3/securities/live'],
    excludedParams: ['date'],
  },
];

/**
 * Returns the parameter value or undefined if it should be excluded for AladdinPortfolioBuilderServer endpoints
 * @param url - The API endpoint URL
 * @param paramName - The parameter name
 * @param value - The parameter value
 * @returns The value if not excluded, undefined otherwise
 */
export function conditionalParam<T>(url: string | undefined, paramName: string, value: T): T | undefined {
  return baseConditionalParam(url, paramName, value, APB_SERVER_PARAM_EXCLUSION_RULES);
}
